import USFlag from 'Shared/icons/flags/us.svg';
import AUFlag from 'Shared/icons/flags/au.svg';
import CAFlag from 'Shared/icons/flags/ca.svg';
import DEFlag from 'Shared/icons/flags/de.svg';
import FRFlag from 'Shared/icons/flags/fr.svg';
import UKFlag from 'Shared/icons/flags/uk.svg';
import EUFlag from 'Shared/icons/flags/eu.svg';
import ITFlag from 'Shared/icons/flags/it.svg';
import { CSSProperties } from 'react';
import { StoreType } from '..';

const StoreFlag = ({
   localeCode,
   style,
   // @ts-expect-error TS(2322) FIXME: Type 'null' is not assignable to type 'string'.
   id = null,
}: {
   localeCode: StoreType['localeCode'];
   style?: CSSProperties;
   id?: string;
}) => {
   const svgProps = {
      style,
      id,
      'data-country': localeCode,
   };

   switch (localeCode) {
      case 'en-au': {
         return <AUFlag {...svgProps} />;
      }
      case 'en-ca': {
         return <CAFlag {...svgProps} />;
      }
      case 'de-de': {
         return <DEFlag {...svgProps} />;
      }
      case 'fr-fr': {
         return <FRFlag {...svgProps} />;
      }
      case 'en-gb': {
         return <UKFlag {...svgProps} />;
      }
      case 'en-eu': {
         return <EUFlag {...svgProps} />;
      }
      case 'en-us': {
         return <USFlag {...svgProps} />;
      }
      case 'it-it': {
         return <ITFlag {...svgProps} />;
      }
      default: {
         return <USFlag {...svgProps} />;
      }
   }
};

export default StoreFlag;
